import { Icon } from '@scale/scaleui';
import copy from 'copy-to-clipboard';
import { useState, useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

export const CodeBlockCopyButton = ({ code, className }: { code: string; className?: string }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timeout = setTimeout(() => setCopied(false), 1000);
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [copied]);

  return (
    <span className={className} onClick={e => e.stopPropagation()}>
      <button
        type="button"
        onClick={() => {
          copy(code);
          setCopied(true);
        }}
        className={twMerge(
          'group overflow-hidden py-1 text-xs font-medium backdrop-blur transition bg-neutral-700/30 hover:bg-neutral-700/40',
        )}
      >
        {copied ? (
          <Icon
            icon={['fas', 'check']}
            className="w-3 h-3 fill-neutral-300/50 stroke-success-500"
            variant="white"
          />
        ) : (
          <Icon
            icon={['far', 'clipboard']}
            className="w-3 h-3 fill-neutral-300/50 stroke-neutral-300"
            variant="white"
          />
        )}
      </button>
    </span>
  );
};
